/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_One_WorkerInputs */

const en_marketing_one_worker = /** @type {(inputs: Marketing_One_WorkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`one Worker`)
};

const es_marketing_one_worker = /** @type {(inputs: Marketing_One_WorkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`un Worker`)
};

const fr_marketing_one_worker = /** @type {(inputs: Marketing_One_WorkerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`un seul Worker`)
};

/**
* | output |
* | --- |
* | "one Worker" |
*
* @param {Marketing_One_WorkerInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_one_worker = /** @type {((inputs?: Marketing_One_WorkerInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_One_WorkerInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_one_worker(inputs)
	if (locale === "es") return es_marketing_one_worker(inputs)
	return fr_marketing_one_worker(inputs)
});